import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-nested-options',
  templateUrl: './nested-options.component.html',
  styleUrls: ['./nested-options.component.scss']
})
export class NestedOptionsComponent implements OnInit {

  constructor() { }
  show_list = 1;
  @Input() options;
  @Input() title_property;
  @Input() id_property;
  @Input() nested_menu_track;
  @Input() onSelect;
  @Input() menu_details;
  @Input() header;
  @Input() multi_select;
  show_child_option;
  child_option;


  ngOnInit(): void {
    // this.header = "test"


  }
  checkChildOption(option, ev) {
    if (option && option.children && option.children.length) {


      this.child_option = option.children;
      this.show_child_option = true
      setTimeout(() => {
        // let top;
        // this.nested_options_details.left = ev.clientX - ev.layerX + 305;
        // top = ev.clientY - ev.layerY;
        // this.nested_options_details.top = top;
        // this.nested_options_details.display_flag = true;
        this.nested_menu_track['top'] = this.menu_details['top'];
        this.nested_menu_track['left'] = (screen.width - 350) > (ev.clientX - ev.layerX + 305) ? (ev.clientX - ev.layerX + 305) : (ev.clientX - ev.layerX - 305);
        this.nested_menu_track['display_flag'] = true;
        // this.menu_details['header'] = option.header;
        this.nested_menu_track['header'] = option.header;
        // this.nested_menu_track['sub_menu'] = this.nested_menu_track['sub_menu'] ? this.nested_menu_track['sub_menu'] : {};
        this.nested_menu_track['sub_menu'] = {};
      })
    }
    else {
      this.show_child_option = false
    }
  }

  hideSubMenu() {
    this.menu_details['display_flag'] = false;
  }
}
